<template>
	<div class="verify-email-dialog">
		<ConfirmationDialog>
			<template #header>
				<header class="verify-email-dialog__head">
					<img src="~@teaming/common-ui/img/teaming-logo.svg" alt="Opre" />
				</header>
			</template>
			<template #description>
				<main class="verify-email-dialog__body" @click="onBodyClick">
					<h2>{{ $t( "slice-apple.components.VerifyEmailDialog.title" ) }}</h2>
					<p>{{ $t( "slice-apple.components.VerifyEmailDialog.para1" ) }}</p>
					<p class="small" v-html="$t( `slice-apple.components.VerifyEmailDialog.para2` )" />
					<TeamingAlert type="SUCCESS" :class="confirmationClasses">
						{{ $t( "slice-apple.components.VerifyEmailDialog.confirmation" ) }}
					</TeamingAlert>
					<p class="small" v-html="$t( `slice-apple.components.VerifyEmailDialog.para3` )" />
				</main>
			</template>
			<template #actions><span><!-- intentionally empty --></span></template>
		</ConfirmationDialog>
	</div>
</template>

<script>
import { ConfirmationDialog, TeamingAlert } from "@teaming/common-ui";
export default {
	name: "VerifyEmailDialog",
	emits: [ "resend", ],
	components: {
		ConfirmationDialog,
		TeamingAlert,
	},
	props: {
		verificationRequested: {
			type: Boolean,
			required: true,
		},
	},
	computed: {
		confirmationClasses() {
			return {
				"verify-email-dialog-confirmation": true,
				"verify-email-dialog-confirmation--visible": this.verificationRequested,
			};
		},
	},
	methods: {
		onBodyClick( e ) {
			const action = e.target.getAttribute( "data-action" );
			if ( action ) {
				e.preventDefault();
				e.stopPropagation();
				this.$emit( action );
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.verify-email-dialog {
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	width: 100%;
	background-color: $verify-email-dialog-overlay-color;
	z-index: 9999;
	.confirmation-dialog {
		background-color: transparent;
	}
}

.verify-email-dialog__head {
	display: flex;
	justify-content: center;
	padding-top: 1rem;
}

.verify-email-dialog__body {
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	padding: 0 1rem;

	color: $verify-email-dialog-body-color;

	h2 {
		text-align: center;
		@include font-and-line-for(2);
	}

	p {
		@include font-and-line-for(1);
	}

	.small {
		@include font-and-line-for(0);
	}
}

.verify-email-dialog-confirmation {
	display: none;
}

.verify-email-dialog-confirmation--visible {
	display: flex;
}
</style>

<style lang="scss">
.verify-email-dialog__body {
	a, a:visited, a:active, a:hover {
		color: $verify-email-dialog-link-color !important;
	}
}
</style>
